import { Button, Col, Descriptions, Input, Row } from "antd";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import FormInput from "../../component/FormInput";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  UpOutlined,
} from "@ant-design/icons";
import {
  INPUT_TYPE,
  KEY,
  lang,
  MODE_SCREEN,
  STYLE,
} from "../../constants/common.const";
import "./equipment.scss";
import EquipmentContentModal from "./equipmentContentModal";
import classText from "../../models/control/text";
function EquipmentSpecs({
  listData = [],
  mode,
  handlechangeInput = () => {},
  listSpecs = [],
  setDataSpecs,
  specsData,
  clickSave,
  setIsDirty
}) {
  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  const data = JSON.parse(JSON.stringify(listData));
  // Change Input
  const changeInput = (e, item) => {
    const value = e.target ? e.target.value : e;
    handlechangeInput(item.key, value, item.rule, item.type);
  };
  const renderInput = (item) => {
    if (mode !== MODE_SCREEN.VIEW) {
      if (item.type === INPUT_TYPE.MODAL) {
        return (
          <EquipmentContentModal
            error={item.error}
            onCancel={item.onCancel}
            onOK={item.onOk}
            compo={item.modalComponent}
            value={item.value.label}
            labelButton={item.labelButton}
          ></EquipmentContentModal>
        );
      }
      return (
        <FormInput
          onChange={(e) => {
            changeInput(e, item);
            if (item.customChange) {
              item.customChange(e, item);
            }
          }}
          valueObject={item.value}
          disabled={item.disabled}
          refer={item.refer}
          haveEmptyOption={item.haveEmptyOption}
          {...item}
        />
      );
    }
    if (item.type === INPUT_TYPE.SWITCH) {
      return item.value.value === true ? lang.YES : lang.NO;
    }
    if (item.type === INPUT_TYPE.SELECT) {
      return item.value.label;
    }
    return item.type === INPUT_TYPE.DATE
      ? item.value.valueString
      : item.value.label || item.value.value;
  };

  const renderDescriptions = (list) => {
    return (
      <Descriptions className="customEquipmentDes" size="small" column={2} bordered>
        {list.map((item, index) => (
          <Descriptions.Item
            style={{ width: item.span == 1 ? "30%" : "80%" }}
            labelStyle={{
              width: "20%",
              fontWeight: "bold",
            }}
            contentStyle={{ padding: "4px 4px" }}
            key={index}
            label={
              <div className="labelInputEquipment">
                {item.title}
                {mode !== MODE_SCREEN.VIEW && item.required && (
                  <span style={{ color: "red" }}>*</span>
                )}
              </div>
            }
            span={item.span || 1}
          >
            {renderInput(item)}
          </Descriptions.Item>
        ))}
      </Descriptions>
    );
  };
  const handleAddRow = () => {
    const newRow = {
      key: Date.now(),
      value: new classText(),
      title: new classText(),
    };
    const newListSpecs = listSpecs.concat(newRow);

    //   const new
    setDataSpecs({
      ...specsData,
      listSpecs: newListSpecs,
    });
  };
  const handleDeleteRow = (key) => {
    const newListSpecs = listSpecs.filter((item) => item.key !== key);
    setDataSpecs({
      ...specsData,
      listSpecs: newListSpecs,
    });
    setIsDirty(true)
  };
  const handleChangeValueRow = (key, field, value) => {
    const newListSpecs = listSpecs.map((item) => {
      if (item.key === key) {
        return {
          ...item,
          [field]: new classText(value),
        };
      }
      return item;
    });
    setDataSpecs({
      ...specsData,
      listSpecs: newListSpecs,
    });
    setIsDirty(true)
  };
  const renderInputListSpecs = (list) => {
    return list.map((item, index) => (
      <Row
        key={index}
        align="middle"
        gutter={8}
        style={{
          marginBottom: 8,
        }}
        className="mt10"
      >
        <Col className="mr10" style={{ width: 36 }}>
          <Button
            onClick={() => {
              handleDeleteRow(item.key);
            }}
            icon={
              <DeleteOutlined
                style={{
                  color: "red",
                }}
              />
            }
            size="small"
            style={{
              width: 32,
              height: 32,
              minWidth: 32,
              borderRadius: 4,
            }}
          />
        </Col>
        <Col flex={1}>
          <Input
            className={
              String(item.title.value).trim() === "" &&
              String(item.value.value).trim() &&
              clickSave
                ? STYLE.BORDER_RED
                : ""
            }
            onChange={(e) => {
              handleChangeValueRow(item.key, "title", e.target.value);
            }}
            value={item.title.value}
          />
        </Col>
        <Col flex={2}>
          <Input
            className={
              String(item.title.value).trim() &&
              String(item.value.value).trim() === "" &&
              clickSave
                ? STYLE.BORDER_RED
                : ""
            }
            onChange={(e) => {
              handleChangeValueRow(item.key, "value", e.target.value);
            }}
            value={item.value.value}
          />
        </Col>
      </Row>
    ));
  };
  if (mode === MODE_SCREEN.VIEW) {
    listSpecs.forEach((item) => {
      const finalItem = {
        ...item,
        title: item.title.value,
        type: INPUT_TYPE.INPUT,
        rule: [],
        span: 2,
      };
      data.push(finalItem);
    });
  }
  return (
    <div style={{
      overflowX:"hidden"
    }}>
      {renderDescriptions(data)}
      {mode !== MODE_SCREEN.VIEW && renderInputListSpecs(listSpecs)}
      {mode !== MODE_SCREEN.VIEW && (
        <div className={"mt15"}>
          <Button
           disabled={listSpecs.length === 10}
            className="buttonPC button--info"
            onClick={() => {
              handleAddRow();
            }}
          >
            <PlusOutlined /> {lang.ADD}
          </Button>
        </div>
      )}
    </div>
  );
}

export default EquipmentSpecs;
